<script>
import { mapGetters, mapState } from 'vuex'

export default {
	props: {
		//
	},
	data: function() {
		return {
			//
		};
	},
	created: function() {
		this.$store.dispatch('cart/getProducts');
	},
	methods: {
		//
	},
    computed: {
        ...mapState({
        	products: state => state.cart.products
        }),
        ...mapGetters('cart', {
            // products: 'cartProducts',
            // total: 'cartTotalPrice'
        }),
        countProdutos: function() {
        	return this.products.length;
        }
    }
};
</script>